import React from "react";
import useViewport from "components/UseViewport/UseViewport";
import { Col, Row, Typography } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
import { IsOpenType } from "interfaces/events";
import { StyledCol, StyledHeaderImage, TotalStyledDiv, StyledCard, StyledRow } from "./style";
import RegisterButton from "./RegisterButton/RegisterButton";

const { Title, Paragraph, Text } = Typography;

interface Props {
  imageLink: string;
  alt: string;
  month: string;
  date: string;
  dayAndTime: string;
  location: string;
  id: number;
  open: string;
  name: string;
  isOpen: IsOpenType;
}

const EventHeader: React.FC<Props> = ({
  imageLink,
  alt,
  month,
  date,
  dayAndTime,
  location,
  id,
  open,
  name,
  isOpen,
}) => {
  const { width } = useViewport();
  const breakpoint = 850;

  return (
    <>
      <TotalStyledDiv style={width < breakpoint ? { marginBottom: "200px" } : { marginBottom: "70px" }}>
        <StyledHeaderImage src={imageLink} alt={alt} />

        <StyledCard
          style={width < breakpoint ? { left: "0", width: "100%", borderRadius: 0 } : { left: "10%", width: "80%" }}
        >
          <StyledRow>
            <Col span={width < breakpoint ? 24 : 3} style={{ textAlign: "center", paddingTop: ".7em" }}>
              <Text style={width < breakpoint ? { fontSize: "2.5em" } : { fontSize: "1.3em" }}>{month}</Text>
              {width >= breakpoint ? <br /> : " "}
              <Text style={{ fontSize: "2.5em" }}>{date}</Text>
            </Col>

            <StyledCol span={width < breakpoint ? 24 : 15} style={width < breakpoint ? { borderLeft: "none" } : {}}>
              <Row style={width < breakpoint ? { justifyContent: "center" } : { paddingLeft: "3%" }}>
                <Paragraph>{dayAndTime}</Paragraph>
              </Row>
              <Row style={width < breakpoint ? { justifyContent: "center" } : { paddingLeft: "3%" }}>
                <Title level={4}>{name}</Title>
              </Row>
              <Row style={width < breakpoint ? { justifyContent: "center" } : { paddingLeft: "3%" }}>
                <Col>
                  <Text>
                    <EnvironmentOutlined style={{ marginRight: "0.4em" }} />
                    {location}
                  </Text>
                </Col>
              </Row>
            </StyledCol>

            <Col
              span={width < breakpoint ? 24 : 6}
              style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "10px 0" }}
            >
              <RegisterButton eventId={id} open={open} isOpen={isOpen} />
            </Col>
          </StyledRow>
        </StyledCard>
      </TotalStyledDiv>
    </>
  );
};

export default EventHeader;
